<template>
  <v-dialog v-model="dialog">
    <template v-slot:activator="{ on }">
      <slot name="activator" :on="on"></slot>
    </template>
    <v-card>
      <v-card-actions>
      <v-text-field label="검색" v-model="search" outlined hide-details></v-text-field>

      </v-card-actions>
      <v-data-table
        :items="items"
        :headers="headers"
        :loading="loading"
        :search="search"
    :custom-filter="searchByPlateNo"
        class="text-no-wrap"
      >
        <template v-slot:body="{ items }">
          <tbody>
            <tr v-for="item in items" :key="item.name" @click="select(item)">
              <td>{{ item.group }}</td>
              <td>{{ item.plateNo }}</td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-card>
  </v-dialog>
</template>

<script>
import { getDeviceList } from '@/api'
import get from 'lodash/get'
export default {
  data () {
    return {
      dialog: false,
      devices: [],
      search: '',
      headers: [
        {
          text: '노선',
          value: 'group'
        },
        {
          text: '차량번호',
          value: 'plateNo'
        }
      ],
      loading: false
    }
  },
  created () {
    this.fetchDevices()
  },
  computed: {
    items () {
      return this.devices.map(device => {
        const group = get(device, 'group.name', '미지정')
        const plateNo = get(device, 'info.plateNo', '미지정')

        return {
          _id: device._id,
          _gr: device._gr,
          group,
          plateNo
        }
      })
    }
  },
  methods: {
    async fetchDevices () {
      if (this.loading) return
      this.loading = true
      try {
        const query = {
          field: 'info.plateNo',
          populate: 'group'
        }
        const { devices } = await getDeviceList(null, query)
        this.devices = devices
      } catch (err) {
        console.error(err)
      }
      this.loading = false
    },
    select (item) {
      this.$emit('input', item)
      this.dialog = false
    },
    searchByPlateNo (value, search, item) {
      return value !== null && search !== null && typeof value === 'string' && value.indexOf(search) !== -1
    }
  }
}
</script>
